import type { MenuSection } from '@botto/core';

export const menu: MenuSection = {
  id: 'sms',
  title: 'SMS',
  icon: 'message',
  items: [
    { title: 'Направления', to: '/sms/directions', icon: 'map' },
    { title: 'Агрегаторы', to: '/sms/aggregators', icon: 'globe' },
    { title: 'Учетные записи', to: '/sms/accounts', icon: 'group' },
    { title: 'Маршрутизация', to: '/sms/routing-choices', icon: 'fork' },
    { title: 'Имена отправителей', to: '/sms/sender-names', icon: 'user' },
    { title: 'Шаблоны сообщений', to: '/sms/message-templates', icon: 'docfile' },
    { title: 'Типы сообщений', to: '/sms/message-types', icon: 'tags' },
    { title: 'Домены', to: '/sms/domains', icon: 'globe' },
    { title: 'Стоп-слова', to: '/sms/keywords', icon: 'find' },
    { title: 'Статистика', to: '/sms/stats', icon: 'chart' },
    { title: 'Ссылки', to: '/sms/links', icon: 'link' },
    { title: 'Отправка SMS', to: '/sms/send-sms', icon: 'export' },
  ],
};
